import { SnackbarType } from "~/core/enums";

export default function getSnackBarLogic() {
  const showSnackbar = ref<boolean>(false);
  const snackbarMessage = ref<string>("No Message");
  const snackbarType = ref<SnackbarType>(SnackbarType.success);

  function showSnackbarFunc(message: string, type: SnackbarType): void {
    showSnackbar.value = false;
    snackbarMessage.value = message;
    showSnackbar.value = true;
    snackbarType.value = type;
  }

  function hideSnackbarFunc(): void {
    showSnackbar.value = false;
  }

  return {
    showSnackbar,
    hideSnackbarFunc,
    snackbarMessage,
    showSnackbarFunc,
    snackbarType,
  };
}
